var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{attrs:{"id":"videoElement","controls":"","autoplay":"","muted":"","width":"100%"},domProps:{"muted":true}}),_c('button',{on:{"click":_vm.play}},[_vm._v("播放")])])
}
var staticRenderFns = []

export { render, staticRenderFns }